module.exports = __webpack_public_path__ + "img/ali_1x1.7df605bf.webp";